import { useState } from "react";
import CustomButton from "../../../Components/Buttons/Custom";
import ModalSimple from "../../../Components/ModalSimple";
import AnnouncementModalCreate from "./AnnouncementModalCreate";

export default function Buttons() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="w-full flex gap-2.5 items-center justify-end">
        <CustomButton
          text="ایجاد اعلان جدید"
          svg_name="add"
          svgClassName="stroke-zi-border-light size-3"
          className="w-full max-w-48 !rounded-lg bg-zi-gradient-button-blue text-zi-text-dark hocus:ring-offset-1 hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-light hocus:ring-offset-zi-blue-light"
          textShadow={true}
          svgShadow={true}
          onClick={() => setShowModal(true)}
        />
      </div>

      {showModal && (
        <ModalSimple showModal={showModal} setShowModal={setShowModal}>
          <AnnouncementModalCreate onClose={() => setShowModal(false)} />
        </ModalSimple>
      )}
    </>
  );
}
